import { Pipe, PipeTransform } from '@angular/core';
import { TaskStatus } from 'src/app/components/tasks/TaskStatus';

@Pipe({
  name: 'task_status'
})
export class StatusPipe implements PipeTransform {

  transform(status: number) {
    if (status == TaskStatus.inactive) {
        return 'Ready to Start'
    } else if (status == TaskStatus.active) {
        return 'Started - In Progress'
    } 
    else if (status == TaskStatus.awaiting_client) {
        return 'Awaiting Client'
    } else if (status == TaskStatus.completed) {
      return 'Completed'
  }
    else if (status == TaskStatus.client_hold) {
        return 'Client Intervention'
    } else if (status == TaskStatus.paused) {
        return 'Paused'
    } else if (status == TaskStatus.awaiting_previous_task) {
        return 'Requires Finishing Previous Task In Project'
    } else if (status == TaskStatus.awaiting_missing_info) {
        return 'Awaiting Missing Info'
    }
    return status;
  }
}
